var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "topic-content" } }, [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c("img", {
            attrs: {
              src: require("../../assets/images/gif-loading.gif"),
              alt: "loading..."
            }
          })
        ])
      : _vm.initialized
        ? _c("div", { attrs: { id: "charts" } }, [
            _c(
              "div",
              { staticClass: "row row-cols-1 row-cols-lg-2" },
              _vm._l(_vm.subcateg.charts, function(chart, index) {
                return _c("ChartBlock", {
                  key: chart.id,
                  attrs: {
                    index: index,
                    chart: chart,
                    columnsTitle: _vm.columnsTitle,
                    years: _vm.subcateg.years,
                    location: _vm.location,
                    temporalData: _vm.temporalData,
                    categ: _vm.categ,
                    subcateg: _vm.subcateg,
                    wmtslist: _vm.wmtslist
                  }
                })
              }),
              1
            )
          ])
        : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }